import styled from 'styled-components';

const SearchKeywordWrapper = styled.div`
  overflow: hidden;
  padding: 10px 10px 0 15px;
  text-align: ${({ left }) => (left ? 'start' : 'center')};
  user-select: none;
  ${({ margin }) => (margin ? `margin: ${margin};` : null)};
`;

export default SearchKeywordWrapper;
